function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.313848 5.59999C0.713848 5.99999 1.31385 5.99999 1.71385 5.59999L4.91385 2.39999L8.21385 5.59999C8.61385 5.99999 9.21385 5.99999 9.61385 5.59999C9.81385 5.39999 9.91385 5.19999 9.91385 4.89999C9.91385 4.69999 9.81385 4.39999 9.61385 4.19999L5.61385 0.299994C5.21385 -0.100006 4.61385 -0.100006 4.21385 0.299994L0.213849 4.19999C-0.0861511 4.59999 -0.0861511 5.19999 0.313848 5.59999Z",
  fill: "black"
});

function SvgArrow({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMC4zMTM4NDggNS41OTk5OUMwLjcxMzg0OCA1Ljk5OTk5IDEuMzEzODUgNS45OTk5OSAxLjcxMzg1IDUuNTk5OTlMNC45MTM4NSAyLjM5OTk5TDguMjEzODUgNS41OTk5OUM4LjYxMzg1IDUuOTk5OTkgOS4yMTM4NSA1Ljk5OTk5IDkuNjEzODUgNS41OTk5OUM5LjgxMzg1IDUuMzk5OTkgOS45MTM4NSA1LjE5OTk5IDkuOTEzODUgNC44OTk5OUM5LjkxMzg1IDQuNjk5OTkgOS44MTM4NSA0LjM5OTk5IDkuNjEzODUgNC4xOTk5OUw1LjYxMzg1IDAuMjk5OTk0QzUuMjEzODUgLTAuMTAwMDA2IDQuNjEzODUgLTAuMTAwMDA2IDQuMjEzODUgMC4yOTk5OTRMMC4yMTM4NDkgNC4xOTk5OUMtMC4wODYxNTExIDQuNTk5OTkgLTAuMDg2MTUxMSA1LjE5OTk5IDAuMzEzODQ4IDUuNTk5OTlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K";
export { SvgArrow as ReactComponent };